var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgSignupCircles = function SvgBgSignupCircles(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 602,
    viewBox: "0 0 602 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_602_38265)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 301,
    r: 300.5,
    transform: "matrix(-1 0 0 1 602 0)",
    stroke: "#94D0CD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 228,
    r: 228,
    transform: "matrix(-1 0 0 1 529 73)",
    fill: "#C3E5E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 153,
    r: 153,
    transform: "matrix(-1 0 0 1 454 148)",
    fill: "#E1F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    transform: "matrix(-1 0 0 1 543 84)",
    fill: "#C3E5E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_38265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 602,
    height: 602,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgSignupCircles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/bg-signup-circles.39e9141682495bcfc0f84890d3a6917a.blank.svg";